export const ageGroups = [
  'S_MINI', 'MINI', 'CHILD', 'TEEN_AGE', 'YOUTH_A', 'YOUTH_B', 'JUNIOR', 'ADULT', 'SENIOR'
];